import Vue from 'vue';
import { authProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';

export default Vue.extend({
  computed: {
    isUserAdmin(): boolean {
      return (authProvider(this.$store) as any).isUserAdmin;
    },

    // Should be user class type
    getCurrentUser(): any {
      return (authProvider(this.$store) as any).getCurrentUser;
    }
  }
});
